import TargetType from './TargetType'

const historyReducer = (state, action) => {
  switch (action.type) {
    case TargetType.GET_TARGETS:
      return {
        ...state,
        phase: action.payload,
        loading: false,
      }
    case TargetType.GET_TARGET:
      return {
        ...state,
        target: action.payload,
        loading: false,
      }
    case TargetType.CREATE_TARGET:
      return {
        ...state,
        target: action.payload,
        loading: false,
      }
    case TargetType.UPDATE_TARGET:
      return {
        ...state,
        target: action.payload,
        loading: false,
      }
    case TargetType.DELETE_TARGET:
      return {
        ...state,
        target: {},
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default historyReducer
